var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-outline-info btn-block ripple-parent",attrs:{"href":_vm.url}},[_vm._v("Login with Zoho")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }